goog.provide('el8.appshared.dialog.createPatient');

goog.require('el8.app.pageLayout');
goog.require('el8.appchart.permissions');
goog.require('el8.appshared.dialog.patientFields');
goog.require('el8.data.base');
goog.require('el8.data.practiceUsers');
goog.require('el8.data.employers');
goog.require('el8.service.urls');
goog.require('el8.template.appshared.dialog.createPatient');
goog.require('el8.template.appshared.location');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.amplitude.patientChartHelpers');
goog.require('el8.util.dom');
goog.require('el8.util.string');

el8.appshared.dialog.createPatient = (function(){

    var saveCallbackFn = null;
    var defaultSaveButtonCaption = 'Create Chart';
    var defaultSaveAndOpenCaption = 'Create & Open Chart';


    var that = new el8.uiwidget.FormDialog({
        title: 'Create New Patient Chart',
        modal: false,
        autoHeight: true,
        position: 'center',
        width: 705,
        contentFn: function() {
            var physicians = el8.data.practiceUsers.getPhysicianUsers();
            /** ARGH, Have to hard-code for DJ/DC **/
            if (el8.data.currPractice.getId() === 73395929092) {
                physicians.reverse();
            }
            return el8.template.appshared.dialog.createPatient.content({
                physicians: physicians,
                languages: el8.data.languages.getPrioritizedMaps(),
                phoneTypes: el8.data.phoneTypes, // this and next 4 are soft loaded on init()
                races: el8.data.races,
                ethnicities: el8.data.ethnicities,
                sexualOrientations: el8.data.sexualOrientations,
                genderIdentities: el8.data.genderIdentities,
                pharmacies: [],
                kareoIntegrated: el8.data.currPractice.isKareoIntegrated(),
                apptRemindersEnabled: el8Globals.FEATURES.ApptReminders &&
                                      el8.data.practiceSettings.isApptRemindersEnabled(),
                employers: [] // will populate with updateEmployerOptions
            });
        }
    });

    var form = null;
    var fn = _.bind(el8.appshared.dialog.patientFields.getFields, that);
    form = new el8.uiwidget.Form({
        fields: fn(),
        validationOpts: el8.appshared.dialog.patientFields.patientValidationOpts
    });

    form.addButtonSane('save-and-open', defaultSaveAndOpenCaption, function() {
        if (!form.isValid()) { return; }
        if (!el8.appshared.dialog.patientFields.insuranceFreeTextFieldsValid(form)) {
            el8.uiwidget.alert('The insurance entered is unknown, please select from the dropdown of existing insurances.');
            return;
        }
        createChart(true);
        if (form.amplitudeSource) { el8.util.amplitude.logStartPatientChart(form.amplitudeSource); }
        that.hide();
    }, {
      isPrimary: true,
      testId: 'create-patient-dialog-save-open-button'
    });
    form.addButtonSane('save', defaultSaveButtonCaption, function() {
        if (!form.isValid()) { return; }
        if (!el8.appshared.dialog.patientFields.insuranceFreeTextFieldsValid(form)) {
            el8.uiwidget.alert('The insurance entered is unknown, please select from the dropdown of existing insurances.');
            return;
        }
        createChart(false);
        if (form.amplitudeSource) { el8.util.amplitude.logStartPatientChart(form.amplitudeSource); }
        that.hide();
    }, {
      testId: 'create-patient-dialog-save-button'
    });
    form.addButtonSane('cancel', 'Discard', function() {
        that.hide();
    }, {
      testId: 'create-patient-dialog-discard-button'
    });
    that.setForm(form);

    var super_init = that._init;
    that._init = function() {
        el8.appshared.dialog.patientFields.softLoadPatientFormInfo();
        el8.appshared.dialog.patientFields.addRemoveSettingDependentFields(form);

        super_init.call(that);
        el8.appshared.dialog.patientFields.addPharmacyLinkListeners(that); //listeners for .change-pharmacy1 and 2
        el8.appshared.dialog.patientFields.addInsuranceLinkListeners(that);
        el8.appshared.dialog.patientFields.addGuarantorLinkListeners(that);
        el8.appshared.dialog.patientFields.addPatientProviderLinkListeners(that);
        el8.appshared.dialog.patientFields.addSecondarySectionListener(that, 'insurance');
        el8.appshared.dialog.patientFields.addSecondarySectionListener(that, 'race');
        el8.appshared.dialog.patientFields.addSecondarySectionListener(that, 'ethnicity');
        el8.appshared.dialog.patientFields.addSecondarySectionListener(that, 'nok');
        el8.appshared.dialog.patientFields.autoTrimEmailListener(that);
        el8.appshared.dialog.patientFields.populateAndSetReferringProviderState(that);
        el8.appshared.dialog.patientFields.populateAndSetPrimaryCareProviderState(that);

        $('.chart-management-section', that.getContentElt()).empty();
        // we don't show the "add to care team" link in creating new patient
        $('.add-referring-provider-to-care-team', that.getContentElt()).empty();
    };

    var super_show = that.show;
    that.show = function(opts) {
        opts = opts || {};

        if (el8Globals.FEATURES.NewDemographics) {
            el8React.dispatch.openCreatePatientDialog({
                initialName: opts.name || null,
                onSuccess: opts.saveCallbackFn || null
            });
            return;
        }

        super_show.call(that);
        form.amplitudeSource = opts.amplitudeSource || null;
        saveCallbackFn = opts.saveCallbackFn || null;
        if (opts.name) {
            var nameObj = el8.util.string.convertNameStr(opts.name);
            form.setVal('firstName', nameObj['firstName']);
            form.setVal('lastName', nameObj['lastName']);
        }
        if (opts.alertMsg) {
            $('.alert-msg', that.getContainer()).text(opts.alertMsg).show();
        } else {
            $('.alert-msg', that.getContainer()).hide();
        }
        form.updateButtonCaption('save', opts.saveButtonCaption || defaultSaveButtonCaption);
        // if there's a custom caption, we're making the chart to fulfill some extra action and likely don't want to open it
        if (opts.saveButtonCaption) {
            form.hideButton('save-and-open');
            form.getButtonSet().makeButtonPrimary('save');
        } else {
            form.showButton('save-and-open');
            form.getButtonSet().makeButtonSecondary('save');
        }
        // Default current user as primary physician, if user is physician
        if (el8.data.currUser.isPhysician()) {
            form.setVal('primaryPhysicianUserId', el8.data.currUser.getId());
        }
        form.getInputField('preferredLanguageId').chosen().trigger('chosen:updated');

        // the list is practice-dependent.  We only show the list of employers
        // that are associated with the current practice
        el8.appshared.dialog.patientFields.updateEmployerOptions(that, form);
        form.getInputField('employerId').chosen().trigger('chosen:updated');

        el8.appshared.dialog.patientFields.updateReferringProviderLinks(that);

        // Prevents stickiness with chosen widget
        form.getInputField('detailedRace').chosen().trigger('chosen:updated');
        form.getInputField('detailedSecondaryRace').chosen().trigger('chosen:updated');
        form.getInputField('detailedEthnicity').chosen().trigger('chosen:updated');
        form.getInputField('detailedSecondaryEthnicity').chosen().trigger('chosen:updated');

        // These secondary sections are by default visible, and are set according to patient data.
        // In this case there's no pt, and so they need to be hidden on show(). hide() also has to
        // hide them, to reset the HTML state in case this dlg is opened again
        el8.appshared.dialog.patientFields.setSecondarySectionVisible(that, 'race', false);
        el8.appshared.dialog.patientFields.setSecondarySectionVisible(that, 'ethnicity', false);

        // we'll disable the insurance fields if we're one way kareo integrated
        el8.appshared.dialog.patientFields.disableInsuranceFieldsIfOneWayKareoIntegrated(that);
        // reset any insurance error classes from previous openings
        el8.appshared.dialog.patientFields.resetInsuranceFreeTextErrorClasses(that.getForm());

        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        // Since this is always a new pt, reset any non-form ins data we have and rerender to clear
        // the embedded insurance templates (and guarantor)
        that._primaryInsurance = null;
        that._secondaryInsurance = null;
        el8.appshared.dialog.patientFields.populateInsuranceFields(that);

        that._guarantor = null;
        el8.appshared.dialog.patientFields.renderGuarantor(that);

        super_hide.call(that);

        $('.alert-msg', that.getContainer()).empty();
        el8.appshared.dialog.patientFields.setSecondarySectionVisible(that, 'insurance', false);
        el8.appshared.dialog.patientFields.setSecondarySectionVisible(that, 'race', false);
        el8.appshared.dialog.patientFields.setSecondarySectionVisible(that, 'ethnicity', false);
        clearPharmacies();
    };

    that.getPatient = function() {
        // polymorphic with editPatient, where this is useful
        return null;
    };

    /**
     * When we save an insurance company from the react insurance dialog, we want to
     * populate the insurance company fields with what was created/updated.
     *
     * @param {object} insuranceCompany - the insurance company from redux
     * @param {string} insuranceRank - either primary or secondary
     */
    that.populateInsuranceCompanyFromReact = function(insuranceCompany, insuranceRank) {
        el8.appshared.dialog.patientFields.populateInsuranceCompanyFromReact(that, insuranceCompany, insuranceRank);
    };

    /**
     * When we save an insurance plan from the react insurance dialog, we want to
     * populate the insurance plan fields with what was created/updated.
     *
     * @param {object} insurancePlan - the insurance plan from redux
     * @param {string} insuranceRank - either primary or secondary
     */
    that.populateInsurancePlanFromReact = function(insurancePlan, insuranceRank) {
        el8.appshared.dialog.patientFields.populateInsurancePlanFromReact(that, insurancePlan, insuranceRank);
    };

    function clearPharmacies() {
        el8.appshared.dialog.patientFields.updatePreferredPharmacy(that, 1, null);
        el8.appshared.dialog.patientFields.updatePreferredPharmacy(that, 2, null);
    }

    function createChart(openChart) {
        el8.appservice.notifier.notify('Creating new patient chart...');
        var postMap = form.getMapped(true, true);
        postMap = el8.appshared.dialog.patientFields.prepareInsuranceDataForPost(postMap, that);
        postMap = el8.appshared.dialog.patientFields.prepareGuarantorDataForPost(postMap, that);
        $.el8_ajax({
            url: el8.service.urls.get('patientDemographics'),
            type: 'POST',
            data: JSON.stringify(postMap),
            success: function(data) {
                if (saveCallbackFn) { saveCallbackFn(data); }
                if (openChart) { el8.util.dom.openBackgroundTab('/patient/'+data.id+'/'); }
                el8.appservice.notifier.notify('New patient chart created.');
            }
        });
    }

    return that;
})();
